import React from 'react';

const NoData = () => (
  <h5 className="text-center pt2 pb2">Not enough data</h5>
);

export default NoData;
